/**
 * Transfer Data Component
 */
 (function() {

    'use strict';

    /**
     * TransferData details form
     * @name transferDataConditions
     * @type ItxTransferDataConditionsCtrl
     * @param {object} transferDataConditionsForm  Objeto donde tenemos el formulario angular
     * @param {string} sections secciones que se quieren mostrar 
     * @param {string} prefix prefijo a añadir para poner id
     */
    var TransferDataConditionsCmp = {
        bindings: {
            model: '=',
        },
        controller: TransferDataConditionsCmpCtrl,
        controllerAs: '$ctrl',
        templateUrl: 'transfer-data-conditions.component.html'
    };

    TransferDataConditionsCmpCtrl.$inject = [
        
    ];

    function TransferDataConditionsCmpCtrl( // jshint ignore:line
    ) 
    {
        var _this = this;
        _this.idRandom = _.uniqueId('transfer_data_');
        
        _this.$onInit = function() {
            _this.model.transfer_data = false;
        };
    }

    angular.module('itxApp.common')
        .component('transferDataConditions', TransferDataConditionsCmp);

})();